import { useLayoutEffect, useMemo } from 'react';
import { getReportContext, ReportContext, ReportStore } from './ReportContext';
import { getOrCreateReportStoreManager } from './ReportStoreManager';
import { AuthenticationType } from '@sas-dvr/internal-va-react-core/utils/authorization';

export type useReportContextOptions = (
  | {
      url: string;
      reportUri: string;
      authenticationType: AuthenticationType;
    }
  | {
      packageUri: string;
    }
) & {
  objectName?: string | number;
  contextKey?: string;
  graphCSS?: string;
};

export function useReportContext(opts: useReportContextOptions) {
  const { objectName } = opts;
  const context = getReportContext({
    ...opts,
    isFullReport: objectName === undefined,
  });
  useLayoutEffect(() => {
    // TODO: Not safe in concurrent mode.
    context.addToViewSet(objectName);
    context.retain();
    return () => {
      context.removeFromViewSet(objectName);
      context.release();
    };
  }, [context, objectName]);

  return context;
}

export function useReportStore(
  reportContext: ReportContext,
  elementKey: string,
  objectName?: string | number
): ReportStore {
  const storeManager = useMemo(() => {
    return getOrCreateReportStoreManager(reportContext, elementKey, objectName);
  }, [elementKey, reportContext, objectName]);

  useLayoutEffect(() => {
    storeManager.retain();
    return () => storeManager.release();
  }, [storeManager]);

  return storeManager.store;
}
